import PT from 'prop-types';
import cx from 'classnames';

const createMarkup = (text) => ({ __html: text });

const JeddleMultiChoiceOption = ({
  name,
  label,
  value,
  showResult,
  checked,
  isCorrect,
  onChange,
  disabled,
}) => (
  <li className="radio">
    <label>
      <div
        className={cx('input-wrapper', {
          'is-correct': isCorrect,
          checked: checked,
          'show-result': showResult,
        })}
      >
        <input
          type={'radio'}
          name={name}
          checked={checked}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <span dangerouslySetInnerHTML={createMarkup(label)} />
      </div>
    </label>
  </li>
);

JeddleMultiChoiceOption.propTypes = {
  name: PT.string,
  value: PT.oneOfType([PT.number, PT.string]).isRequired,
  showResult: PT.bool,
  checked: PT.bool,
  isCorrect: PT.bool,
  onChange: PT.func.isRequired,
  label: PT.string,
  disabled: PT.bool,
};

JeddleMultiChoiceOption.defaultProps = {
  showResult: false,
  checked: false,
  isCorrect: false,
  disabled: false,
  label: '',
};

export default JeddleMultiChoiceOption;
